import { useEffect, useState } from "react";

type Props = {
  imageUrl: string;
  title: string;
  thumbSize?: number;
};

export function ClickToZoomTailwind({
  imageUrl,
  title,
  thumbSize = 200,
}: Props) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="cursor-zoom-in"
        aria-label="Открыть изображение в модальном окне"
      >
        <div
          className="overflow-hidden rounded bg-gray-50 shrink-0"
          style={{ width: thumbSize, height: thumbSize }}
        >
          <img
            src={imageUrl}
            alt={title}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        </div>
      </button>

      {open && (
        <div
          role="dialog"
          aria-modal="true"
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-2"
          onClick={(e) => {
            if (e.target === e.currentTarget) setOpen(false);
          }}
        >
          <div className="relative">
            <img
              src={imageUrl}
              alt={title}
              className="w-[500px] h-[500px] object-contain cursor-zoom-out"
              onClick={() => setOpen(false)}
            />
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Закрыть"
              className="absolute right-2 top-2 rounded-md bg-black/60 px-2 py-1 text-white"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
}
